import { __read, __assign } from 'tslib';
import { EVENT_TYPE } from './constants.js';

var emit = function (event, logsOnly) {
    if (logsOnly === void 0) { logsOnly = false; }
    if (logsOnly) {
        console.groupCollapsed("Analytics Event: ".concat(event.eventAction));
        console.table(Object.entries(event)
            .filter(function (_a) {
            var _b = __read(_a, 2); _b[0]; var value = _b[1];
            return value;
        })
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return ({ key: key, value: value });
        }));
        console.groupEnd();
        return;
    }
    if (typeof window !== 'undefined') {
        window.sravniDataLayer = window.sravniDataLayer || [];
        window.sravniDataLayer.push(__assign({ eventLabel: undefined, eventValue: undefined }, event));
    }
};
var makeMainEvent = function (event) { return (__assign(__assign({ eventLabel: undefined, eventValue: undefined }, event), { event: EVENT_TYPE.MAIN_EVENT })); };

export { emit, makeMainEvent };
//# sourceMappingURL=helpers.js.map
